export default __webpack_public_path__ + "static/media/francs10_logo.c309c0e1.png";